import { useState, useEffect } from "react";
import { animated, useTransition } from "react-spring";

function LogoCarousel({ logos, interval = 1500 }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((index) => (index + 1) % logos.length);
    }, interval);

    return () => clearInterval(timer);
  }, [interval, logos.length]);

  const transitions = useTransition(logos[index], {
    key: logos[index].src,
    from: { opacity: 0, transform: "translate3d(-100%,0,0)" },
    enter: { opacity: 1, transform: "translate3d(0%,0,0)" },
    leave: { opacity: 0, transform: "translate3d(100%,0,0)" },
  });

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      {transitions((style, logo) => (
        <animated.img
          src={logo.src}
          alt={logo.alt}
          style={{
            ...style,
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      ))}
    </div>
  );
}

export default LogoCarousel;
